function themeSwitcher(){
    const toggleElm = document.querySelector('.toggle-theme--js');
    const toggles = toggleElm.querySelectorAll('[data-theme]');

    const cookiedTheme = document.cookie.split("; ").find((r) => r.startsWith("theme="))?.split("=")[1];

    toggles.forEach((toggle) => {
        
        if(cookiedTheme != '' && typeof(cookiedTheme) != "undefined"){
            toggle.classList.remove('active');
            if(toggle.dataset.theme === 'theme-' + cookiedTheme) toggle.classList.add('active');
        }

        toggle.addEventListener('click', (e) => {
            e.stopPropagation();

            const themeSlug = e.currentTarget.dataset.theme;

            switch (themeSlug){
                case "theme-dark" :
                    document.documentElement.classList.remove('theme-light-forced');
                    document.documentElement.classList.add('theme-dark-forced');
                    document.cookie = "theme=dark; expires=Fri, 31 Dec 9999 23:59:59 GMT;";
                    break;
                case "theme-light" :
                    document.documentElement.classList.remove('theme-dark-forced');
                    document.documentElement.classList.add('theme-light-forced');
                    document.cookie = "theme=light; expires=Fri, 31 Dec 9999 23:59:59 GMT;";
                    break;
                default:
                    document.documentElement.classList.remove('theme-dark-forced');
                    document.documentElement.classList.remove('theme-light-forced');
                    document.cookie = "theme=";
            }

            toggles.forEach((toggle) => toggle.classList.remove('active'));
            e.currentTarget.classList.add('active');
        });
    })
}

export { themeSwitcher };